export enum PermissionKeys {
  TENANT_READ = 'TENANT_READ',
  TENANT_ONBOARDING_DATAZONE_NONPII = 'TENANT_ONBOARDING_DATAZONE_NONPII',
  TENANT_ONBOARDING_DATAZONE_PII = 'TENANT_ONBOARDING_DATAZONE_PII',
  TENANT_ONBOARDING_DATAZONE_LIVE = 'TENANT_ONBOARDING_DATAZONE_LIVE',
  INSTANCE_SFTP_CONFIG_DATAZONE_NONPII = 'INSTANCE_SFTP_CONFIG_DATAZONE_NONPII',
  INSTANCE_SFTP_CONFIG_DATAZONE_PII = 'INSTANCE_SFTP_CONFIG_DATAZONE_PII',
  INSTANCE_SFTP_CONFIG_DATAZONE_LIVE = 'INSTANCE_SFTP_CONFIG_DATAZONE_LIVE',
  BLUEPRINT_READ = 'BLUEPRINT_READ',
  INSTANCE_UPDATE_DATAZONE_NONPII = 'INSTANCE_UPDATE_DATAZONE_NONPII',
  INSTANCE_UPDATE_DATAZONE_PII = 'INSTANCE_UPDATE_DATAZONE_PII',
  INSTANCE_UPDATE_DATAZONE_LIVE = 'INSTANCE_UPDATE_DATAZONE_LIVE',
  INSTANCE_EXTEND_DATAZONE_NONPII = 'INSTANCE_EXTEND_DATAZONE_NONPII',
  INSTANCE_EXTEND_DATAZONE_PII = 'INSTANCE_EXTEND_DATAZONE_PII',
  INSTANCE_EXTEND_DATAZONE_LIVE = 'INSTANCE_UPDATE_DATAZONE_LIVE',
  INSTANCE_READ_DATAZONE_NONPII = 'INSTANCE_READ_DATAZONE_NONPII',
  INSTANCE_READ_DATAZONE_PII = 'INSTANCE_READ_DATAZONE_PII',
  INSTANCE_READ_DATAZONE_LIVE = 'INSTANCE_READ_DATAZONE_LIVE',
  INSTANCE_DR_DATAZONE_LIVE = 'INSTANCE_DR_DATAZONE_LIVE',
  INSTANCE_CONFIG_DATAZONE_NONPII = 'INSTANCE_CONFIG_DATAZONE_NONPII',
  INSTANCE_CONFIG_DATAZONE_PII = 'INSTANCE_CONFIG_DATAZONE_PII',
  INSTANCE_CONFIG_DATAZONE_LIVE = 'INSTANCE_CONFIG_DATAZONE_LIVE',

  INSTANCE_DELETE_DATAZONE_NONPII = 'INSTANCE_DELETE_DATAZONE_NONPII',
  INSTANCE_DELETE_DATAZONE_PII = 'INSTANCE_DELETE_DATAZONE_PII',
  INSTANCE_DELETE_DATAZONE_LIVE = 'INSTANCE_DELETE_DATAZONE_LIVE',
  INSTANCE_START_DATAZONE_NONPII = 'INSTANCE_START_DATAZONE_NONPII',
  INSTANCE_START_DATAZONE_PII = 'INSTANCE_START_DATAZONE_PII',
  INSTANCE_STOP_DATAZONE_NONPII = 'INSTANCE_STOP_DATAZONE_NONPII',
  INSTANCE_STOP_DATAZONE_PII = 'INSTANCE_STOP_DATAZONE_PII',
  INSTANCE_CREATE_DATAZONE_NONPII = 'INSTANCE_CREATE_DATAZONE_NONPII',
  INSTANCE_CREATE_DATAZONE_PII = 'INSTANCE_CREATE_DATAZONE_PII',
  INSTANCE_CREATE_DATAZONE_LIVE = 'INSTANCE_CREATE_DATAZONE_LIVE',
  INSTANCE_REDEPLOY_DATAZONE_NONPII = 'INSTANCE_REDEPLOY_DATAZONE_NONPII',
  INSTANCE_REDEPLOY_DATAZONE_PII = 'INSTANCE_REDEPLOY_DATAZONE_PII',
  INSTANCE_REDEPLOY_DATAZONE_LIVE = 'INSTANCE_REDEPLOY_DATAZONE_LIVE',
  BLUEPRINT_CREATE = 'BLUEPRINT_CREATE',
  CONFIGURATION_READ = 'CONFIGURATION_READ',
  INSTANCE_CREATE = 'INSTANCE_CREATE',
  BLUEPRINT_DELETE = 'BLUEPRINT_DELETE',
  BLUEPRINT_UPDATE = 'BLUEPRINT_UPDATE',
  INSTANCE_AGENT_MANAGE_DATAZONE_NONPII = 'INSTANCE_AGENT_MANAGE_DATAZONE_NONPII',
  INSTANCE_AGENT_MANAGE_DATAZONE_PII = 'INSTANCE_AGENT_MANAGE_DATAZONE_PII',
  INSTANCE_AGENT_MANAGE_DATAZONE_LIVE = 'INSTANCE_AGENT_MANAGE_DATAZONE_LIVE',
  SOLUTION_READ = 'SOLUTION_READ',
  SOLUTION_CREATE = 'SOLUTION_CREATE',
  SOLUTION_UPDATE = 'SOLUTION_UPDATE',
  SOLUTION_DELETE = 'SOLUTION_DELETE',
  INSTANCE_TEST_DATAZONE_NONPII = 'INSTANCE_TEST_DATAZONE_NONPII',
  INSTANCE_TEST_DATAZONE_PII = 'INSTANCE_TEST_DATAZONE_PII',
  INSTANCE_TEST_DATAZONE_LIVE = 'INSTANCE_TEST_DATAZONE_LIVE',
}





